import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/ProsetBackButton.css";

const ProsetBackButton = ({ label = "Geri Dön" }) => {
  const navigate = useNavigate();

  return (
    <button className="proset-back-btn" onClick={() => navigate(-1)}>
      <span className="back-icon">←</span>
      {label}
    </button>
  );
};

export default ProsetBackButton;
